import React from 'react'
import { useIntl } from 'react-intl'
import Headline from '@atoms/Headline/Headline'
import type { StoreLocatorResultsProps, StoreProps } from './StoreLocator.types'

export const StoreLocatorResults = ({
  stores,
  font
}: StoreLocatorResultsProps) => {
  const { formatMessage } = useIntl()

  return (
    <div
      className={`${font.regular} my-4 divide-y border-t border-black first:border-none`}
    >
      <Headline tag='h2' className='text-16 md:text-18 mb-4 ml-4 font-bold'>
        {formatMessage(
          {
            defaultMessage: 'We found {count} results near you',
            id: 'msp.storeLocator.result.title'
          },
          { count: stores?.length || 0 }
        )}
      </Headline>
      {stores
        ? stores.map((item: any) => <Store key={item.id} item={item} />)
        : ''}
    </div>
  )
}

const Store = ({ item }: StoreProps) => {
  const { formatMessage } = useIntl()
  const openingHours = eval(item.storeHours ?? '')
  const validOpeningHours = Array.isArray(openingHours) && openingHours.length

  return (
    <div key={item.id}>
      <div className={'justify-between py-4 pl-4 lg:max-w-[41%]'}>
        <p className='text-16 md:text-18 font-medium'>{item.name}</p>
        <div className='text-12 md:text-14 flex flex-row'>
          <div className='w-1/2 pr-8'>
            <p>{item.address1}</p>
            <p>{`${item.postalCode} ${item.city}`}</p>

            <p>{item.phone}</p>

            <p className='pt-2 font-medium'>
              {formatMessage({
                defaultMessage: 'Distance:',
                id: 'msp.storeLocator.result.distance'
              })}
              {` ${item.distance} ${item.distanceUnit}`}
            </p>
          </div>
          <div className='w-1/2'>
            <p className='pb-4 font-medium'>
              {item.c_storeCategories?.join(', ')}
            </p>
            <div className='flex flex-row'>
              <p className='pr-4 font-medium'>
                {validOpeningHours && openingHours[0]?.day?.children}
              </p>
              <p className='font-medium'>
                {validOpeningHours && openingHours[0]?.time?.children}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
